<template>
    <div class="container-fluid" id="dvcrud">        
        <div class="row">
            <consultafornecedores></consultafornecedores>
            <gerarparcelas v-bind:vproptipo=1></gerarparcelas>
            <baixartitulospagar v-bind:vdtbaixa           = "pdtbasebaixa"
                             v-bind:proplstselecionados     = "vvariaveisbaixar.lstselecionadosbaixa"                             
                             v-bind:vvariaveisbaixarcmp     = "vvariaveisbaixar"
                             v-bind:propvaldescontojuros    = "valdescontojuros"
                             v-bind:propvaldescontomulta    = "valdescontomulta"
                             v-bind:propidlancamentopdv     = "0">
            </baixartitulospagar>
            <detalhestitulopagar  v-bind:idfornecedor = "didfornecedor" 
                                    v-bind:codtit    = "dcodtit" 
                                    v-bind:situacao  = "dsituacao">
            </detalhestitulopagar>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar títulos" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerar títulos" style="margin-right: 10px;" @click.prevent="mtdgerarparcelas()"><span aria-hidden="true"><i class="fa fa-gears"></i></span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Parceiro fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoriapesq" data-placeholder="Selecione uma categoria" data-allow-clear="true"
                                    v-model="pidcategoria" style="width:100%;">
                                </select>
                            </div>                             
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Tipo de cobrança:</span>
                                <select id="cbtipocobrancapesq" v-model="pidtipocobranca"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>                                                      
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcodauxiliarpesq">Cód. Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodauxiliarpesq" v-model="pcodauxiliar"
                                    maxlength="30" data-bv-group=".group" @change="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemitentechequepesq">Emitente(Cheque):</label>
                                <input type="text" class="form-control form-control-sm" id="edemitentechequepesq" v-model="pemitentecheque"
                                    maxlength="30" data-bv-group=".group" @change="mtdlimpar_listagem()">
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbfiltropor">Por:</label>
                                <select class="form-control form-control-sm" id="cbfiltropor" v-model="ppor" @change="mtdlimpar_listagem()">
                                    <option value="0">Data Vencimento</option>
                                    <option value="1">Data Emissão</option>
                                    <option value="2">Data da baixa</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cblistar">Consultar:</label>
                                <select class="form-control form-control-sm" id="cblistar" v-model="pativosinativos" @change="mtdlimpar_listagem()">
                                    <option value="0">Ativos</option>
                                    <option value="1">Inativos</option>
                                    <option value="2" selected="true">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtbasebaixa">Data Base/Baixa:</label>
								<div class="input-group">
									<date-picker id="eddtbasebaixa" v-model="pdtbasebaixa" :config="options" class="form-control form-control-sm" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbSitTitulo">Situação</label>
                                <select class="form-control form-control-sm" id="cbSitTitulo" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Baixados</option>
                                    <option value="2">Cancelados</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2 col-md-offset-2 col-lg-offset-2">
                                <label for="cbordempesq">Ordem:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbordempesq" v-model="pordem" @change="mtdlimpar_listagem()">
                                    <option value="0">Fornecedor</option>
                                    <option value="1">Emissão</option>
                                    <option value="2">Vencimento</option>
                                    <option value="3">Pagamento</option>
                                </select>
                            </div>                                                         
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <!-- visualização para abertos e renegociados -->
                            <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" @on-select-row="mtdcalculaselecionados()"
                                    @on-unselect-row="mtdcalculaselecionados()"
                                    @on-all-select-rows="mtdcalculaselecionados()"
                                    @on-all-unselect-rows="mtdcalculaselecionados()"
                                        :rows="lsttitulos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Editar"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Fechar"><i class="fa fa-ban"></i></button>
                                        <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'A')" title="Informções"><i class="fa fa-info-circle"></i></button>                                        
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                     
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                    <template slot="slot_vlapagar" slot-scope="item">
                                        <span style="color: #5A956A; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlapagar), 2) }}</span>
                                    </template>                                                                         
                                </vue-bootstrap4-table>
                            </div>
                            <!-- visualização dos cancelados -->
                            <div v-show="parseInt(psituacao) === 2" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnscancelados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarcancelamento(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                        <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'C')" title="Informções"><i class="fa fa-info-circle"></i></button>
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div> 
                            <!-- visualização dos baixados -->
                            <div v-show="parseInt(psituacao) === 1" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnsbaixados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarbaixa(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                        <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idfornecedor, item.row.codtit, 'B')" title="Informções"><i class="fa fa-info-circle"></i></button>
                                    </template>
                                    <template slot="slot_nomefornecedor" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idfornecedor, 8) }} - {{ item.row.nomefornecedor }}
                                    </template>
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template> 
                                    <template slot="slot_valordescontojurosmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.valordescontojurosmulta), 2) }}</span>
                                    </template>                                                                                                             
                                    <template slot="slot_vlpago" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlpagtit) + parseFloat(item.row.vljuros) + parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                </vue-bootstrap4-table>
                            </div>                             
                            <div class="col-md-12">
                                <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Em atraso <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Programados <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Carteira total <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Seleção ativa <span class="badge badge-info bdgtitulos">{{ vqtdtitsel }}</span></a>
                                                    <a class="list-group-item lstdetrec">Principal selecionado <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vTotalPagarSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vTotalJurosSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vTotalMultaSel, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total a desembolsar <span
                                                            class="badge badge-success bdgtitulos">{{ mtdformatavalordecimal(vTotalGeralSel, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="parseInt(psituacao) === 1" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total juros <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaljurosrec, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total descontos <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaldescontorec, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotalmultarec, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdetrec">Total liquidado <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotalgeralrec, 2) }}</span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                                <div v-show="parseInt(psituacao) === 2" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total cancelado <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrTotcancelados, 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-2 col-sm-2 col-md-6 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button v-show="parseInt(psituacao) === 0 && lsttitulos.length > 0 && vqtdtitsel > 0" type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdbaixartitulos()"><i class="fa fa-check"></i> Baixar</button>
                            </div> 
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdgerarpdf()"><i class="fa fa-print"></i> Imprimir</button>
                            </div>                                                       
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="edcodcli">*Parceiro fornecedor:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="edcodfor" v-model="vidfornecedor" v-bind:disabled="ativadesativaCodFor" maxlength="11" v-on:blur="mtdlocalizarfornecedor(vidfornecedor)" style="text-transform: uppercase;">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarfornecedor()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-5">
                                <label for="ednomefornecedor">Nome do fornecedor:</label>
                                <input type="text" class="form-control form-control-sm" id="ednomefornecedor" v-model="vnomefornecedor"
                                    data-bv-group=".group" maxlength="50" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="edcodtit">*Nº Título:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodtit" v-model="vcodtit"
                                    v-bind:disabled="ativadesativaCodTit" maxlength="30" style="text-transform: uppercase;"
                                    data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcodtit">Cod. Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edauxiliar" v-model="vcodauxiliar" v-bind:disabled="ativadesativa"
                                    maxlength="30" style="text-transform: uppercase;" data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Tipo de cobrança:</span>
                                <select id="cbtipocobranca" v-model="vidtipocobranca" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Data Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemitit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtvenc">*Data Vencimento:</label>
								<div class="input-group">
									<date-picker id="eddtvenc" v-model="vdtventit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
                            <div class="col-sm-12" v-show="parseInt(tipocob) === 1">
                                <div class="card" id="pnlcheque" style="margin-top: 15px; margin-bottom: 10px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;"><span>DADOS DO CHEQUE</span></div>
                                    <div class="card-body" style="padding-bottom: 15px;">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="ednumcheque">*Nº Cheque:</label>
                                                <input type="text" class="form-control form-control-sm" id="ednumcheque"
                                                    v-model="vnumerocheque" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <span class="lblselect2">*Banco:</span>
                                                <select id="cbbanco" v-model="vidbanco" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um banco" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edagencia">*Agência:</label>
                                                <input type="text" class="form-control form-control-sm" id="edagencia"
                                                    v-model="vagencia" v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edconta">*Conta:</label>
                                                <input type="text" class="form-control form-control-sm" id="edconta" v-model="vconta"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edpraca">*Praça:</label>
                                                <input type="text" class="form-control form-control-sm" id="edpraca" v-model="vpraca"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edemitente">*Emitente:</label>
                                                <input type="text" class="form-control form-control-sm" id="edemitente"
                                                    v-model="vemitente" v-bind:disabled="ativadesativa" maxlength="50"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edcnpjcpfch">*Cnpj/Cpf:</label>
                                                <input type="text" v-mask="['##.###.###/####-##', '###.###.###-##']" class="form-control form-control-sm" id="edcnpjcpfch"
                                                    v-model="vcnpjcpf" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <span class="lblselect2">*Situação do Cheque:</span>
                                                <select id="cbsitcheque" v-model="vidsituacaocheque" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione a situação do cheque" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbsituacao">Situação:</label>
                                <select class="form-control form-control-sm" v-model="vinativo" id="cbsituacao"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Ativo</option>
                                    <option value="1">Inativo</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpjuros">Tipo de juros:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcjuros" id="cbtpjuros"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatjuros">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatjuros" v-bind="money" v-model="vfatjuros"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpmulta">Tipo de multa:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcmulta" id="cbtpmulta"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatmulta">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatmulta" v-bind="money" v-model="vfatmulta"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edvalortit">*Valor do título:</label>
                                <money class="form-control form-control-sm" id="edvalortit" v-bind="money" v-model="vvltit"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right; background: #0acf97; color: white; font-weight: bold;"></money>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="txtobs">Anotações:</label>
                                <textarea class="form-control center" rows="4" id="txtobs" v-model="vobstit"
                                        style="text-transform: uppercase;"
                                        v-bind:disabled="ativadesativa"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Confirmar
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO - CONTAS A PAGAR</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">CENTRAL DE IMPORTAÇÃO</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Fechar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>                
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarFornecedores from '../components/cmpconsultarfornecedores.vue'
    import GerarParcelas from '../components/cmpgerarparcelas.vue'
    import BaixarTitulosPagar from '../components/cmpbaixartitulospagar'
    import DetalhesTituloPagar from '../components/cmpdetalhestitulopagar'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadtitulospagar',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
            'consultafornecedores'  : ConsultarFornecedores,
            'gerarparcelas'         : GerarParcelas,
            'baixartitulospagar'  : BaixarTitulosPagar,
            'detalhestitulopagar' : DetalhesTituloPagar
        },
        data: function() {
            return {
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                lsttitulos          : [],
                pfiltro             : 1,
                pidcategoria        : null,
                pidfilial           : null,
                pidfornecedor       : null,
                pidtipocobranca     : null,
                pcodauxiliar        : '',
                pemitentecheque     : '',
                pativosinativos     : 0,
                pfiltroperiodo      : 1,
                ppor                : 0,
                hab_desab_periodo   : false,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true), 
                pdtbasebaixa        : util.DataAtual(true),
                psituacao           : 0,
                pordem              : 2,      
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                ativadesativaCodFor : false,
                ativadesativaCodTit : false,
                opcrud              : 0,

                tipocob             : 0,//variável para determinar se é cheque ou não

                vidfornecedor       : '',
                vnomefornecedor     : '',
                vcodtit             : '',
                vsttit              : '',
                vcodauxiliar        : '',
                vidtipocobranca     : null,
                vidfilial           : null,
                vdtemitit           : util.DataAtual(true),
                vdtventit           : util.DataAtual(true),
                vnumerocheque       : '',
                vidbanco            : null,
                vagencia            : '',
                vconta              : '',
                vpraca              : '',
                vemitente           : '',
                vcnpjcpf            : '',
                vidsituacaocheque   : null,
                vinativo            : 0,
                vtpcalcjuros        : 0,
                vfatjuros           : 0,
                vtpcalcmulta        : 0,
                vfatmulta           : 0,
                vvltit              : 0,
                vobstit             : '',


                //variável para habilitação dos campos
                ativadesativa       : true,

                //variaveis de somas totais
                vrVencidos          : 0,
                vrAvencer           : 0,
                vrJuros             : 0,
                vrMulta             : 0,
                vrTotal             : 0,
                vrTotcancelados     : 0,

                //variaveis de somas dos baixados
                vtotaltitulosrec    : 0,
                vtotaljurosrec      : 0,
                vtotalmultarec      : 0,
                vtotaldescontorec   : 0,
                vtotalgeralrec      : 0,          

                //variáveis para os totais dos selecionados
                vqtdtitsel          : 0,
                vTotalPagarSel      : 0,
                vTotalJurosSel      : 0,
                vTotalMultaSel      : 0,
                vTotalGeralSel      : 0,                

                //baixa de titulo
                valdescontojuros         : 0,
                valdescontomulta         : 0,
                vvariaveisbaixar : {
                    vtottitbaixa         : 0,
                    vtotmultabaixa       : 0,
                    vtotjurosbaixa       : 0,
                    vtotpagarbaixa       : 0,
                    lstselecionadosbaixa : [],
                    vvalorrecebimento    : 0,
                },

                //variaveis para detalhe do título
                didfornecedor        : '',
                dcodtit              : '',
                dsituacao            : 'A',//A - Aberto, B - Baixado, C - Cancelado, R - Renegociado

                //variável da importação
                vlimpardados            : false,
                arqselecionado          : null,    

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CONTAS A PAGAR',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-abertos",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Restante",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
                    {
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                                                              
                    {
                        label: "Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    { 
                        label: "À pagar",
                        name: "vlapagar",
                        sort: true,
                        slot_name: "slot_vlapagar",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                                        
                ],
                columnscancelados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Tipo de cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    }                                        
                ],
                columnsbaixados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Fornecedor",
                        name: "nomefornecedor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomefornecedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomefornecedor",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Pagamento",
                        name: "dtpagtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
					{
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Descto(J/M)",
                        name: "valordescontojurosmulta",
                        sort: true,
                        slot_name: "slot_valordescontojurosmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
					{
                        label: "Total pago",
                        name: "vlpago",
                        sort: true,
                        slot_name: "slot_vlpago",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    }					
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    //rows_selectable: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdconsultarfornecedor(){
				if (parseInt(this.opcrud) < 2){
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_FORNECEDOR_CHANGE',payload);
					let payloadx = {
						idfornecedor    : null			
					};
					this.$store.commit('FORNECEDOR_RETORNO_CHANGE',payloadx);                
				}
            },
            mtdlocalizarfornecedor(idfornecedor){
				if (idfornecedor !== '' && idfornecedor !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and f.id='+idfornecedor},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let fornecedor = response.data[0];							
							vself.vidfornecedor  			    = fornecedor.id;
							vself.vnomefornecedor 				= fornecedor.nomerazaosocial;
							$('#edcodtit').focus();
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidfornecedor 	= '';
							vself.vnomefornecedor 	= '';
							$('#edcodfor').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.vidfornecedor 	= '';
					this.vnomefornecedor 	= '';
				}
            },                        
            mtdfiltropesquisa(){
                let rfiltro = '';
                if(this.pidfilial !== null) {                    
                    rfiltro = ' and t.idfilial=' + this.pidfilial;
                }                 
                if(this.pidfornecedor !== null) {
                    rfiltro = rfiltro + ' and t.idfornecedor=' + this.pidfornecedor;
                }
                if(this.pidtipocobranca !== null) {
                    rfiltro = rfiltro + ' and t.idtipocobranca=' + this.pidtipocobranca;
                }                
                if(this.pcodauxiliar !== '') {
                    rfiltro = rfiltro + ' and t.codauxiliar="' + this.pcodauxiliar+'"';
                }
                if(this.pemitentecheque !== '') {
                    rfiltro = rfiltro + ' and upper(t.emitente) like upper("%' + this.pemitentecheque+'%")';
                }                                
				if(parseInt(this.pfiltroperiodo) === 1){
                    let strpor = parseInt(this.ppor) === 0 ? 'dtventit' : parseInt(this.ppor) === 1 ? 'dtemitit' : 'dtpagtit';
					rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                }
                if(this.pidcategoria !== null) {                    
                    rfiltro = rfiltro + ' and forn.idcategoria=' + this.pidcategoria;
                } 
                if (parseInt(this.psituacao) !== 1){
                    if(parseInt(this.pativosinativos) < 2){
                        rfiltro = rfiltro + ' and t.inativo='+this.pativosinativos;
                    }
                }
                switch (parseInt(this.psituacao)) {
                    case 0 :
                        rfiltro = rfiltro + ' and t.sttit in ("A", "P")';
                        break;
                    case 2 :
                        rfiltro = rfiltro + ' and t.sttit="C"';
                        break;
                    case 3 :
                        rfiltro = rfiltro + ' and t.sttit="R"';
                        break;
                }                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatitulos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregatitulos(ipagina){
                var vself       = this;                    
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                vself.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table 
                vself.mtdcalculaselecionados();                   
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(vself.pdtbasebaixa)},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    vself.lsttitulos = response.data.lista;
                    //iguala totais dos titulos para calcular os selecionados
                    if (parseInt(vself.psituacao) !== 1){
                        vself.vrVencidos        = response.data.vencidos;
                        vself.vrAvencer         = response.data.avencer;
                        vself.vrJuros           = response.data.totjuros;
                        vself.vrMulta           = response.data.totmulta;
                        vself.vrTotal           = response.data.totgeral;
                        vself.vrTotcancelados   = response.data.totcancelados;                        
                    }else{
                        vself.vtotaltitulosrec  = response.data.totaltitulos;
                        vself.vtotaljurosrec    = response.data.totaljuros;
                        vself.vtotalmultarec    = response.data.totalmulta;
                        vself.vtotaldescontorec = response.data.totaldescontos;
                        vself.vtotalgeralrec    = response.data.totgeral;                             
                    }
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttitulos = [];
                    loader.hide();
                });
            },
            mtdselect2_def(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                
				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
				});
                
				$("#cbcategoriapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcategorias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcategoria = $("#cbcategoriapesq").val();
                });
                                
				$("#cbtipocobrancapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidtipocobranca = $("#cbtipocobrancapesq").val();
                });                
                
                //selects crud
				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.vidtipocobranca !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.tipocob = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.tipocob = 0;
                            loader.hide();
                        });
                    }else{
                        vself.tipocob = 0;
                    }
                });
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                });
				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbanco = $("#cbbanco").val();
                });
				$("#cbsitcheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidsituacaocheque = $("#cbsitcheque").val();
                });                                                                       
            },
            resetarDados() {
                util.toTop();

                this.tipocob             = 0;

                this.vidfornecedor          = '';
                this.vnomefornecedor        = '';
                this.vcodtit             = '';
                this.vsttit              = '';
                this.vcodauxiliar        = '';
                this.vidtipocobranca     = null;
                this.vidfilial           = null;
                this.vdtemitit           = util.DataAtual(true);
                this.vdtventit           = util.DataAtual(true);
                this.vnumerocheque       = '';
                this.vidbanco            = null;
                this.vagencia            = '';
                this.vconta              = '';
                this.vpraca              = '';
                this.vemitente           = '';
                this.vcnpjcpf            = '';
                this.vidsituacaocheque   = null;
                this.vinativo            = 0;
                this.vtpcalcjuros        = 0;
                this.vfatjuros           = 0;
                this.vtpcalcmulta        = 0;
                this.vfatmulta           = 0;
                this.vvltit              = 0;
                this.vobstit             = '';

                $("#cbfilial").val(null).trigger('change');
                $("#cbtipocobranca").val(null).trigger('change');
                $("#cbbanco").val(null).trigger('change');
                $("#cbsitcheque").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#edcodfor').focus();
                    } else if(parseInt(this.opcrud) === 2){
                        $('#edauxiliar').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
                if (parseInt(op) > 1) {
                    vself.ativadesativaCodFor = true;
                    vself.ativadesativaCodTit = true;
                }else{
                    vself.ativadesativaCodFor = false;
                    vself.ativadesativaCodTit = false;
                }
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.040Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO - CONTAS A PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lsttitulos             = [];
                this.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table
                this.pagina_atual           = 1;
                this.filtro                 = '';
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas           = 0;
                this.vrVencidos             = 0;
                this.vrAvencer              = 0;
                this.vrJuros                = 0;
                this.vrMulta                = 0;
                this.vrTotal                = 0;
                this.vrTotcancelados        = 0;
                //variáveis dos baixados    
                this.vtotaltitulosrec       = 0;
                this.vtotaljurosrec         = 0;
                this.vtotalmultarec         = 0;
                this.vtotaldescontorec      = 0;
                this.vtotalgeralrec         = 0;   

                this.mtdcalculaselecionados();
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(idfornecedor, codtit){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and t.idfornecedor='+idfornecedor+' and t.codtit="'+codtit+'"';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lista[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.040Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO - CONTAS A PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.idfornecedor, item.codtit);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.040Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CANCELAMENTO - CONTAS A PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.idfornecedor, item.codtit);
                }
            },
            mtdigualarcampos(registro){
                    this.vidfornecedor           = registro.idfornecedor;
                    this.vnomefornecedor         = registro.nomefornecedor;
                    this.vcodtit              = registro.codtit;
                    this.vcodauxiliar         = registro.codauxiliar;
                    this.vsttit               = registro.sttit;
                    this.vidtipocobranca      = registro.idtipocobranca;
                    this.vtipocobranca        = registro.ipocob;  
                    this.vdtemitit            = registro.dtemitit;
                    this.vdtventit            = registro.dtventit;
                    this.vdtpagtit            = registro.dtpagtit;
                    this.vvltit               = registro.vltit;
                    this.vvlresta             = registro.vlresta;
                    this.vtpcalcjuros         = registro.tpcalcjuros;
                    this.vtpcalcmulta         = registro.tpcalcmulta;
                    this.vfatjuros            = registro.fatjuros;
                    this.vfatmulta            = registro.fatmulta;
                    this.vobstit              = registro.obstit;
                    this.vobstitsis           = registro.obstitsis;
                    this.vnumerocheque        = registro.numerocheque;
                    this.vidbanco             = registro.idbanco;
                    this.vagencia             = registro.agencia;
                    this.vconta               = registro.conta;
                    this.vpraca               = registro.praca;
                    this.vcnpjcpf             = registro.cnpjcpf;
                    this.vemitente            = registro.emitente,
                    this.vidsituacaocheque    = registro.idsituacaocheque;
                    this.vidfilial            = registro.idfilial;
                    this.vvlpagtit            = registro.vlpagtit;
                    this.vnossonumero         = registro.nossonumero;
                    this.vultimojuros         = registro.ultimojuros;
                    this.vdtultpagtit         = registro.dtultpagtit;
                    this.vinativo             = registro.inativo;

                    var deffilial        = new Option(registro.fantasia, registro.idfilial, true, true);
                    $('#cbfilial').append(deffilial).trigger('change');

                    var deftipocobranca  = new Option(registro.desccob, registro.idtipocobranca, true, true);
                    $('#cbtipocobranca').append(deftipocobranca).trigger('change');
                   
                    if (parseInt(registro.tipocobranca) === 1){
                        var defbanco    = new Option(registro.descbanco, registro.idbanco, true, true);
                        $('#cbbanco').append(defbanco).trigger('change');

                        var defsitch    = new Option(registro.descsitch, registro.idsituacaocheque, true, true);
                        $('#cbsitcheque').append(defsitch).trigger('change');                        
                    }else{
                        $("#cbbanco").val(null).trigger('change');
                        $("#cbsitcheque").val(null).trigger('change');
                    }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let fantasiafilial = $('#cbfilial').select2('data')[0]['text'];
                let nomefornecedor    = vself.vnomefornecedor; 
                let registrocrud = {
                    'idfornecedor'           : this.vidfornecedor,
                    'codtit'              : this.vcodtit,
                    'codauxiliar'         : this.vcodauxiliar,
                    'sttit'               : this.vsttit,
                    'idtipocobranca'      : this.vidtipocobranca,
                    'tipocobranca'        : this.tipocob,  
                    'dtemitit'            : this.vdtemitit,
                    'dtventit'            : this.vdtventit,
                    'dtpagtit'            : this.vdtpagtit,
                    'vltit'               : this.vvltit,
                    'vlresta'             : this.vvlresta,
                    'tpcalcjuros'         : this.vtpcalcjuros,
                    'tpcalcmulta'         : this.vtpcalcmulta,
                    'fatjuros'            : this.vfatjuros,
                    'fatmulta'            : this.vfatmulta,
                    'obstit'              : this.vobstit,
                    'obstitsis'           : this.vobstitsis,
                    'numerocheque'        : this.vnumerocheque,
                    'idbanco'             : this.vidbanco,
                    'agencia'             : this.vagencia,
                    'conta'               : this.vconta,
                    'praca'               : this.vpraca,
                    'cnpjcpf'             : this.vcnpjcpf !== null || this.vcnpjcpf !== "" ? this.vcnpjcpf.replace(/[^0-9]/g,'') : "",
                    'emitente'            : this.vemitente,
                    'idsituacaocheque'    : this.vidsituacaocheque === null ? 0 : this.vidsituacaocheque,
                    'idfilial'            : this.vidfilial,
                    'vlpagtit'            : this.vvlpagtit,
                    'ultimojuros'         : this.vultimojuros,
                    'dtultpagtit'         : this.vdtultpagtit,
                    'inativo'             : this.vinativo
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.040Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.040Z.020Z' : '030Z.040Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pidfilial      = registrocrud.idfilial;
                        vself.pidfornecedor     = registrocrud.idfornecedor;
                        vself.pcodauxiliar   = '';
                        vself.pfiltroperiodo = 0;
                        vself.ppor           = 0;
                        vself.pativosinativos= 2;
                        vself.psituacao      = 0;
                        vself.pordem         = 2;
                        vself.pqtd_paginas   = 1;

                        var deffilial        = new Option(fantasiafilial, registrocrud.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');

                        var deffornecedor       = new Option(nomefornecedor, registrocrud.idfornecedor, true, true);
                        $('#cbfornecedorpesq').append(deffornecedor).trigger('change');                        

                        vself.mtdcancelaredicao();
                        vself.mtdcarregatitulos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdzerarselecionados() {
                this.vTotalPagarSel       = 0;
                this.vTotalJurosSel       = 0;
                this.vTotalMultaSel       = 0;
                this.vTotalGeralSel       = 0;
            },            
            mtdcalculaselecionados() {
                this.mtdzerarselecionados();
                for (var i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                    this.vTotalPagarSel    = this.vTotalPagarSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                    this.vTotalJurosSel    = this.vTotalJurosSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                    this.vTotalMultaSel    = this.vTotalMultaSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                    this.vTotalGeralSel    = this.vTotalGeralSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlapagar);
                }
                this.vqtdtitsel = this.$refs.reflsttitulos.selected_items.length;
            },
            mtdbaixartitulos(){
                if (!util.opcaousuario('030Z.040Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (parseInt(this.pordem) !== 2){
                        this.$toastr.w('Para baixa, a ordem dos títulos deve estar por data de vencimento!', 'Atenção!');
                        $("#cbordempesq").focus();
                        return;
                    }
                    this.vvariaveisbaixar.vtottitbaixa         = this.vTotalPagarSel;
                    this.vvariaveisbaixar.vtotjurosbaixa       = this.vTotalJurosSel;
                    this.vvariaveisbaixar.vtotmultabaixa       = this.vTotalMultaSel;
                    this.vvariaveisbaixar.vtotpagarbaixa       = this.vTotalGeralSel;
                    this.valdescontojuros                      = this.vTotalJurosSel;
                    this.valdescontomulta                      = this.vTotalMultaSel;
                    this.vvariaveisbaixar.lstselecionadosbaixa = this.$refs.reflsttitulos.selected_items;
                    this.vvariaveisbaixar.vvalorrecebimento    = this.vTotalGeralSel;

                    $('#mdBaixarTitulosPagar').modal('show');
                }
            },
            mtdestornarbaixa(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.040Z.060Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Esse processo irá estornar, também, todos os pagamentos feitos depois deste. Deseja mesmo realizar o estorno do pagamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarbaixa'},
                                        {parametro: 'idmovip',      valor : titulo.id},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.040Z.060Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtdestornarcancelamento(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.040Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma estorno de cancelamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarcancelamento'},
                                        {parametro: 'codtit',       valor : titulo.codtit},
                                        {parametro: 'idfornecedor',    valor : titulo.idfornecedor},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.010Z.050Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulospagar.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtddetalhestitulo(idfornecedor, codtit, situacao){
                if (!util.opcaousuario('030Z.040Z.070Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    this.didfornecedor  = idfornecedor;
                    this.dcodtit        = codtit;
                    this.dsituacao      = situacao;
                    $('#mdDetalhesTitulosPagar').modal('show');
                }
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('030Z.040Z.080Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO - CONTAS A PAGAR';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarcp.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstclientes= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarcp.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=030Z.040Z.080Z';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdgerarpdf(){
                let vself   = this;
                let filtro  = vself.mtdfiltropesquisa();
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulospagar.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&situacao='+vself.psituacao+
                            '&dtbasecalculo='+util.InverterData(vself.pdtbasebaixa)+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordem='+vself.pordem, '_blank');					                
            },
            mtdgerarparcelas(){
                if (!util.opcaousuario('030Z.040Z.090Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                                                     
                    $('#mdgerarparcelas').modal('show');
                }
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('030Z.040Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdcarregatitulos(vself.pagina_atual);
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                if(parseInt(this.tipocob) === 0) {
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vvltit === 0 || this.vdtemitit === '' || this.vdtventit === '';
                }else{
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vvltit === 0 || this.vnumerocheque === '' ||
                            this.vidbanco === null || this.vagencia === '' || this.vconta === '' ||
                            this.vpraca === '' || this.vemitente === '' || this.vcnpjcpf === '' || this.vidsituacaocheque === null || 
                            this.vdtemitit === '' || this.vdtventit === '';
                }
            },
            idfornecedorretorno(){
                return this.$store.state.fornecedorretornoconsulta.idfornecedor;
			},            
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            retornobaixa(){
               return this.$store.state.retornobaixapagar.retorno; 
            }
        },
        watch:{
            idfornecedorretorno(val){
                if (val !== null || val !== ''){
					this.vidfornecedor = val;
					this.mtdlocalizarfornecedor(this.vidfornecedor);					
                }
			},            
            pagina_atual(val){
                this.mtdcarregatitulos(val);
            },
            psituacao(val){
                this.config.checkbox_rows = parseInt(val) === 0 ? true : false;
            },
            retornobaixa(val){
                let vself = this;
                if (parseInt(val) === 1){
                    //dispara a mutation pra esperar pela próxima baixa
                    let payload = {
                        retorno    : 0
                    };
                    vself.$store.commit('RETORNO_BAIXA_PAGAR_CHANGE',payload);
                    vself.pcodauxiliar   = '';
                    vself.pfiltroperiodo = 0;
                    vself.ppor           = 0;
                    vself.pativosinativos= 2;
                    vself.psituacao      = 0;
                    vself.pordem         = 2;
                    vself.pqtd_paginas   = 1;
                    vself.mtdlimpar_listagem();
                    vself.mtdcarregatitulos(1);                    
                }
            },
            psituacao(val){
                if (parseInt(val) === 1){
                    this.pordem = 2;
                }
            }                        
        }
    }
</script>
<style>
    .def-col-opcoes-abertos{
        width: 130px !important;
    }
    .def-col-codtit{
        width: 120px !important;
    }
    .lstdetrec{
        padding: 5px!important;
        font-weight: 700;
        color: #6c757d!important;
    }
    .bdgtitulos{
        margin-top: 2px;
        float : right!important;
        font-size: 12px!important;
        width: 100px!important;
        text-align: right!important;
    }    
</style>
